import { Input } from "../../components/Form";

const NAME_FIELDS = [
  { name: "namesEn", label: "Name (English)", placeholder: "Enter English name" },
  { name: "namesHi", label: "Name (Hindi)", placeholder: "हिंदी नाम दर्ज करें" },
  { name: "namesKn", label: "Name (Kannada)", placeholder: "ಕನ್ನಡ ಹೆಸರು ನಮೂದಿಸಿ" },
];

const LocalizedNameFields = ({ values = {}, onChange, columnClass = "col-4" }) => (
  <>
    {NAME_FIELDS.map(({ name, label, placeholder }) => (
      <div className={columnClass} key={name}>
        <div className="form-group mb-2">
          <Input
            type="text"
            name={name}
            value={values?.[name] || ""}
            onChange={onChange}
            placeholder={placeholder}
            className="form-control"
            label={label}
            maxLength={50}
          />
        </div>
      </div>
    ))}
  </>
);

export const namesFromConsultant = (consultant = {}) => ({
  namesEn: consultant?.names?.en || consultant?.accountName || consultant?.name || "",
  namesHi: consultant?.names?.hi || "",
  namesKn: consultant?.names?.kn || "",
});

export default LocalizedNameFields;
